// Paths used for routing.
export const ROOT_PATH = '/';
export const AGE_ANTISPOOFING_PATH = '/age-antispoofing';
export const FACE_MATCHING_PATH = '/face-matching';
export const LOGIN_PATH = '/login';
export const CALLBACK_PATH = '/auth/:provider/callback';
export const VERIFY_ACCOUNT_PATH = '/verify';
